module.exports = __webpack_public_path__ + "img/fundlist.fb78c07.webp";